// extracted by mini-css-extract-plugin
module.exports = {"block":"_25r9d7Tf","title":"FLklEQUx","content":"_3ntpPIvl","emptyState":"_3mMdSarh"};